import { render, staticRenderFns } from "./AccountsClassificationAdd.vue?vue&type=template&id=7a23fb29&scoped=true&"
import script from "./AccountsClassificationAdd.vue?vue&type=script&lang=js&"
export * from "./AccountsClassificationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a23fb29",
  null
  
)

export default component.exports